import {Pipe, PipeTransform} from '@angular/core';
import {DateMatchPipe} from '@tisa-group/core/pipes/date-match';
import {UmpireMatch} from '@tisa-group/models';

@Pipe({
  name: 'matchPhase',
  standalone: false,
})
export class MatchPhasePipe implements PipeTransform {
  constructor(private readonly _dateMatchPipe: DateMatchPipe) {}

  transform(value: UmpireMatch | undefined | null, timeFormat?: string): string | null {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const incidents = value?.incidents.map(({incident_type}) => incident_type);

    if (incidents?.includes('match_ended')) {
      return 'libs.core.matchPhase.matchEnded';
    }

    if (incidents?.includes('second_half_started')) {
      return 'libs.core.matchPhase.secondHalfStarted';
    }

    if (incidents?.includes('half_time')) {
      return 'libs.core.matchPhase.halfTime';
    }

    if (incidents?.includes('kick_off')) {
      return 'libs.core.matchPhase.kickOff';
    }

    return this._dateMatchPipe.transform(
      value?.postponed_start_time || value?.start_time,
      timeFormat,
    );
  }
}
